'use strict';

const CS = require('./contentSquare');

const isDataLayerDefined = () => {
    return typeof dataLayer !== 'undefined';
};

const pushToDataLayer = (data) => {
    if (!isDataLayerDefined() || !data) {
        return;
    }
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
};

const getTilePosition = (e) => {
    if (!e || typeof e.closest !== 'function') {
        return -1;
    }

    const productRecommandation = e.closest('.product-recommendations');
    const image = productRecommandation.length ? productRecommandation.find('.product-tile > .image-container') : $('.product-tile > .image-container');
    const link = productRecommandation.length ? productRecommandation.find('.link') : $('.link');

    return Math.max(image.index(e) + 1, link.index(e) / 2 + 1);
};

/**
 * Reads the list identifier from the nearest ancestor carrying `data-item-list`
 * and applies it to the ecommerce datalayer object. The list identity lives on
 * the (non-cached) parent container instead of the cached product tile, so the
 * Tile-Show remote include no longer needs an `origin` query param.
 * @param {Object} $el - jQuery element that was clicked
 * @param {Object} ecommerce - ecommerce datalayer object to enrich
 * @returns {void}
 */
const applyItemList = ($el, ecommerce) => {
    if (!ecommerce) {
        return;
    }
    const list = $el.closest('[data-item-list]').attr('data-item-list');
    if (list) {
        ecommerce.item_list_id = list;
        ecommerce.item_list_name = list;
    }
};

const handleClickEvents = () => {
    $('body').on('product:afterAddToCart', (e, data) => {
        if (data.DLEvents && Array.isArray(data.DLEvents)) {
            data.DLEvents.forEach(DLEvent => {
                pushToDataLayer(DLEvent);
            });
        }
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        if (data.DLEvents && Array.isArray(data.DLEvents)) {
            data.DLEvents.forEach(DLEvent => {
                pushToDataLayer(DLEvent);
            });
        }
    });

    $('body').on('cart:update', function (e, data) {
        if (data.DLEvents && Array.isArray(data.DLEvents)) {
            data.DLEvents.forEach(DLEvent => {
                pushToDataLayer(DLEvent);
            });
        }
    });

    // Checkout - Step 1
    $('#checkoutBegin .checkout-btn').click(function (e) {
        e.preventDefault();

        const products = $('orch-cart-product-card').map(function () {
            return $(this).data('product-gtm');
        });

        if (products.length === 1 && products[0].orc_isClubCard === true) {
            $('.error-message').show();
            $('.error-message-text').text(this.dataset.clubCardAloneMessage);
            return;
        }

        // eslint-disable-next-line no-restricted-globals
        location.href = $(this).attr('href');
    });

    // Checkout - Step 3
    $('body').on('checkout:shipping', function () {
        CS.handleContentSquareEvents();
    });

    // Checkout Step 4
    $('body').on('checkout:shippingDone', function (e, data) {
        data.gtmData.forEach(DLEvent => {
            pushToDataLayer(DLEvent);
        });

        CS.handleContentSquareEvents();
    });

    $('body').on('newsletter:subscription', function (e, data) {
        if (data.DLEvents && Array.isArray(data.DLEvents)) {
            data.DLEvents.forEach(DLEvent => {
                pushToDataLayer(DLEvent);
            });
        }
    });

    $('body').on('wishlist:addItem', function (e, data) {
        if (data.DLEvents && Array.isArray(data.DLEvents)) {
            data.DLEvents.forEach(DLEvent => {
                pushToDataLayer(DLEvent);
            });
        }
    });

    // Product Click
    $('body').on('click', '.product-tile .image-container, .product-tile .link-primary', function (e) {
        e.preventDefault();

        var productTile = $(this).closest('.product-tile')[0];
        var $productTile = $(productTile);

        if (productTile.hasAttribute('data-product-gtm') && $productTile.data('product-gtm') !== null) {
            var productGTM = $productTile.data('product-gtm');

            const price = productGTM.ecommerce.items ? productGTM.ecommerce.items[0].price : '0';
            productGTM.ecommerce.items[0].price = parseFloat(price);
            productGTM.ecommerce.items[0].index = getTilePosition($(this));
            productGTM.event = window.GTMConstants.EVENT_TYPE_PRODUCT_CLICK;
            applyItemList($(this), productGTM.ecommerce);
            pushToDataLayer(productGTM);
        } else {
            var customProductGTMObj = {};
            var customProductObj = {};

            customProductObj.item_id = $productTile.parent('.product').attr('data-pid');
            customProductObj.item_name = $productTile.find('.tile-Infos .link-primary').text();
            customProductObj.item_brand = $productTile.find('.tile-Infos .brand-name').text();
            customProductObj.index = ($productTile.closest('.product-grid-region').attr('data-position') * 1);

            if ($productTile.find('.tile-Infos > .price > .range').length > 0) {
                customProductObj.price = parseFloat($productTile.find('.tile-Infos > .price > .range .standard-list-pricing').attr('content'));
            } else {
                customProductObj.price = parseFloat($productTile.find('.tile-Infos > .price .standard-pricing .standard-list .value').attr('content'));
            }

            customProductGTMObj.event = window.GTMConstants.EVENT_TYPE_PRODUCT_CLICK;
            customProductGTMObj.ecommerce = {
                items: [customProductObj]
            };
            applyItemList($(this), customProductGTMObj.ecommerce);
            pushToDataLayer(customProductGTMObj);
        }

        var href;
        if ($(this).hasClass('link-primary')) { // clicked on the link
            href = $(this).attr('href');
        } else { // clicked on the image
            href = $(this).closest('.image-container').find('a').attr('href');
        }

        var productClickDL = dataLayer.find(dl => {
            return dl.event === 'productClick';
        });
        if (productClickDL) {
            // eslint-disable-next-line no-restricted-globals
            const url = new URL(href, location);
            url.searchParams.append('from', productClickDL.ecommerce.detail.actionField.list);
            href = url.toString();
        }

        // eslint-disable-next-line no-restricted-globals
        $(location).attr('href', href);
    });

    // PDP - Open filters
    $('body').on('open-popup', function () {
        pushToDataLayer({ event: window.GTMConstants.EVENT_TYPE_OPEN_FILTERS });
    });

    // PDP - Close filters
    $('body').on('close-popup', function () {
        pushToDataLayer({ event: window.GTMConstants.EVENT_TYPE_CLOSE_FILTERS });
    });
};

const filterEvent = (attribute, name) => {
    var data = window.dataLayer.filter(elmt => elmt[attribute] === name);
    return data.length > 0 ? data[0] : null;
};

const handleMobileTracking = () => {
    // Follow Analytics - Dom
    $(document).ready(function () {
        window.getDomData = function () {
            var domData = filterEvent('event', window.GTMConstants.EVENT_TYPE_DOM);
            return domData ? domData.data : null;
        };
    });

    // Follow Analytics - Purchase
    $('body').on('confirm:init', function () {
        window.getPurchaseData = function () {
            return filterEvent('event', window.GTMConstants.EVENT_TYPE_PURCHASE);
        };
    });

    // Follow Analytics - Cart
    $('body').on('cart:init', function () {
        window.getCartData = function () {
            return filterEvent('pagetype', window.GTMConstants.ECOMM_PAGE_TYPE_PANIER);
        };
    });

    // Follow Analytics - Cart
    $('body').on('plp:init', function () {
        window.getPLPData = function () {
            return filterEvent('event', window.GTMConstants.EVENT_TYPE_LOAD);
        };
    });
};

module.exports = {
    isDataLayerDefined,
    pushToDataLayer,
    handleClickEvents,
    handleMobileTracking,
    getTilePosition
};
